export default __webpack_public_path__ + "static/media/Shops.b4f3da7e.jpg";